<template>
	<div class="contentss">
		<div :class="value==2?'headerss flexbetween':'headers flexbetween'">
			<div class="herder_left">
				<img src="../assets/image/logo.png" mode="" />
			</div>
			<div class="right flexleft">
				<div class="herder_right flexaround">
					<div class="header_child" style="font-weight: bold;" v-for="(item,index) in list"
						@click="toindex(index)">{{item.name}}
						<div class="technologyList">
							<div class="child" style="font-weight: 400;" v-for="(item,index) in techList" :key="index"
								@click="changeTec(item.id)">{{item.title}}</div>
						</div>
						<div class="aboutus">
							<div class="child" style="font-weight: 400;" v-for="(item,index) in serList " :key="index"
								@click="changeSer(item.id)">{{item.title}}</div>
						</div>
						<div class="service">
							<div class="child" style="font-weight: 400;" v-for="(item,index) in aboutList" :key="index"
								@click="change(item.id)">{{item.name}}</div>
						</div>
						<!-- <div class="zzDay">
							<div class="child" v-for="(item,index) in zzList" :key="index" @click="change(item.id)">{{item.name}}</div>
						</div> -->
						<div class="goverment">
							<div class="child" style="font-weight: 400;" v-for="(item,index) in goList" :key="index"
								@click="change(item.id)">{{item.name}}</div>
						</div>
					</div>
				</div>
				<div class="finMatrixNav header_child" style="font-weight: bold;">
					Fin Matrix
					<div class="finMatrixMenu">
						<div class="child" v-for="(item, idx) in finMatrixList" :key="idx"
							@click="openFinMatrixUrl(item.url)">{{ item.name }}</div>
					</div>
				</div>
				<div class="search flexleft" @click="toSearch">
					<input type="text" disabled>
					<img src="../../src/assets/image/search.png" alt="">
				</div>
				<div class="login" @click="toLogin">登录</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "headerTop",
		props: {
			value: {
				type: [String, Number],
				default: 0
			}
		},
		data() {
			return {
				list: [{
					name: '首页'
				}, {
					name: '关于我们'
				}, {
					name: '创投服务'
				}, {
					name: '企业服务'
				},
				// {
				// 	name: '投教基地'
				// },
				{
					name: '政策资讯'
				},
				// {
				// 	name: '创投日报'
				// },
				],
				techList: [],
				aboutList: [{
					name: '区位优势',
					id: 8,
				}, {
					name: '发展历程',
					id: 9,
				}, {
					name: '成果荣誉',
					id: 10,
				}, {
					name: '入驻机构',
					id: 7,
				}],
				serList: [],
				zzList: [{
					name: '创投专家企业行'
				}, {
					name: '银政企对接会'
				}, {
					name: '股权融资路演'
				}, {
					name: '企业家沙龙'
				}, {
					name: '专精特新融资训练营'
				}, {
					name: '产业链对接活动'
				}, {
					name: '创投咖啡俱乐部'
				}, {
					name: '创投精英训练营'
				}, {
					name: '基金入豫活动'
				}, {
					name: '科技成果转化'
				}, ],
				goList: [{
					name: '政策公告',
					id: 11,
				}, {
					name: '广场动态',
					id: 12,
				}, ],
				finMatrixList: [{
					name: 'AI科创问答',
					url: 'https://kejijinrong-ai.com/AI',
				}, {
					name: 'AI估值',
					url: 'https://kejijinrong-ai.com/aiTools?mode=1',
				}, {
					name: 'AI诊断',
					url: 'https://kejijinrong-ai.com/aiTools?mode=2',
				}, {
					name: 'AI BP',
					url: 'https://kejijinrong-ai.com/AIBP',
				}],
			};
		},
		created() {
			this.getlist();
			this.getqylist();
		},
		methods: {
			toLogin() {
				window.open('https://cc.kjjrgc.com/pc/#/index');
			},
			toSearch() {
				this.$router.push({
					name: 'search'
				});
			},
			openFinMatrixUrl(url) {
				window.open(url, '_blank');
			},
			toindex(index) {
				if (index == 0) {
					this.$router.push({
						name: 'index'
					})
				} else if (index == 4) {
					this.$router.push({
						name: 'policy'
					});
				}
				// ——以下为导航中含「投教基地」项时的索引逻辑（保留备查，勿删）——
				// } else if (index == 4) {
				// 	window.open(
				// 		'http://mp.weixin.qq.com/mp/homepage?__biz=MzU1NjcyNDU1OQ==&hid=1&sn=09b6e51a403ce09e779734a68b56afb6&scene=18#wechat_redirect',
				// 		'_blank');
				// 	// 或站内：this.$router.push({ name: 'study' })
				// } else if (index == 5) {
				// 	this.$router.push({
				// 		name: 'policy'
				// 	});
				// }
				// else if (index == 6) {
				// 	window.open(
				// 		'https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzU1NjcyNDU1OQ==&action=getalbum&album_id=2715355540427882498#wechat_redirect',
				// 		'_blank');
				// }
			},
			//关于我们列表
			getlist() {
				let _this = this;
				_this.$api.user.fundServicesList().then(res => {
					if (res.code == 1) {
						_this.serList = res.data;
					}
				})
			},
			//企业服务列表
			getqylist() {
				let _this = this;
				_this.$api.user.enterpriseServicesList().then(res => {
					if (res.code == 1) {
						_this.techList = res.data;
					}
				})
			},
			changeSer(id) {
				if (id == 1) {
					this.$router.push({
						name: 'bgHuanjing',
						query: {
							id: id
						}
					})
				} else if (id == 2) {
					this.$router.push({
						name: 'rzLiucheng',
						query: {
							id: id
						}
					})
				} else if (id == 3) {
					this.$router.push({
						name: 'mtGuantui',
						query: {
							id: id
						}
					})
				} else if (id == 4) {
					this.$router.push({
						name: 'jjZhuce',
						query: {
							id: id
						}
					})
				} else if (id == 5) {
					this.$router.push({
						name: 'fwAnli',
						query: {
							id: id
						}
					})
				}
			},
			changeTec(id) {
				if (id == 1) {
					this.$router.push({
						name: 'fwTixi',
						query: {
							id: id
						}
					})
				} else if (id == 2) {
					this.$router.push({
						name: 'cxPingtai',
						query: {
							id: id
						}
					})
				} else if (id == 3) {
					this.$router.push({
						name: 'jrfuCs',
						query: {
							id: id
						}
					})
				} else if (id == 4) {
					this.$router.push({
						name: 'fwAnlis',
						query: {
							id: id
						}
					})
				}
			},
			change(id) {
				if (id == 11) {
					this.$router.push({
						name: 'policy'
					})
				} else if (id == 12) {
					this.$router.push({
						name: 'square'
					})
				} else if (id == 7) {
					this.$router.push({
						name: 'aboutus'
					})
				} else if (id == 8) {
					this.$router.push({
						name: 'qwYoushi'
					})
				} else if (id == 9) {
					this.$router.push({
						name: 'fzLiucheng'
					})
				} else if (id == 10) {
					this.$router.push({
						name: 'cgRongyu'
					})
				}
			},
		},
	}
</script>

<style scoped lang="scss">
	.login {
		cursor: pointer;
		margin-right: 4vw;
		padding: 10px 20px;
		font-size: 20px;
		color: #fff;
	}

	.contentss {
		overflow: hidden;
	}

	.headers {
		position: fixed;
		top: 0;
		width: 100%;
		max-width: 1920px;
		z-index: 100;
		background-color: rgba(11, 79, 221, 0.4);

		.herder_left {
			margin-left: 4vw;
			cursor: pointer;

			img {
				object-fit: fill;
				width: 230px;
				height: 50px;
			}
		}

		.herder_left:hover {
			animation: bigs .3s linear forwards;
		}

		.right {
			.herder_right {
				position: relative;

				.header_child {
					text-align: center;
					width: 132px;
					padding: 40px 0;
					line-height: 16px;
					font-family: AlibabaPuHuiTiR;
					font-size: 16px;
					color: #ffffff;
					cursor: pointer;
					position: relative;
				}

				.header_child:hover {
					animation: big .3s linear forwards;

					// .child{
					// 	font-weight: 400;
					// }
				}

				.service {
					display: none;
					position: absolute;
					top: 96px;
					background-color: #fff;
					width: 110px;
					margin: 0 15px;

					.child {
						width: 100%;
						padding: 20px 0;
						font-family: AlibabaPuHuiTiR;
						font-size: 16px;
						color: #666;
						opacity: 0.68;
						text-align: center;
					}

					.child:hover {
						animation: change .3s linear forwards;
					}
				}

				.aboutus {
					display: none;
					position: absolute;
					top: 96px;
					background-color: #fff;
					width: 110px;
					margin: 0 15px;

					.child {
						width: 100%;
						padding: 20px 0;
						font-family: AlibabaPuHuiTiR;
						font-size: 16px;
						color: #666;
						opacity: 0.68;
						text-align: center;
					}

					.child:hover {
						animation: change .3s linear forwards;
					}
				}

				.technologyList {
					display: none;
					position: absolute;
					top: 96px;
					background-color: #fff;
					width: 110px;
					margin: 0 15px;

					.child {
						width: 100%;
						padding: 20px 0;
						font-family: AlibabaPuHuiTiR;
						font-size: 16px;
						color: #666;
						opacity: 0.68;
						text-align: center;
					}

					.child:hover {
						animation: change .3s linear forwards;
					}
				}

				.zzDay {
					display: none;
					position: absolute;
					top: 96px;
					background-color: #fff;
					width: 110px;
					margin: 0 15px;

					.child {
						width: 100%;
						padding: 20px 0;
						font-size: 16px;
						color: #666;
						opacity: 0.68;
						text-align: center;
					}

					.child:hover {
						animation: change .3s linear forwards;
					}
				}

				.goverment {
					display: none;
					position: absolute;
					top: 96px;
					right: 0;
					background-color: #fff;
					width: 110px;
					margin: 0 15px;

					.child {
						width: 100%;
						padding: 20px 0;
						font-size: 16px;
						color: #666;
						opacity: 0.68;
						text-align: center;
					}

					.child:hover {
						animation: change .3s linear forwards;
					}
				}

				.header_childs {
					text-align: center;
					width: 150px;
					padding: 20px 0;
					font-family: AlibabaPuHuiTiR;
					font-size: 14px;
					color: #666;
					background-color: #0049ac;
					cursor: pointer;
				}

				// 含「投教基地」共六项导航时，政策资讯为第6个子项：
				// .header_child:nth-child(6):hover {
				// 	.goverment {
				// 		display: block;
				// 	}
				// }
				// .header_child:nth-child(5):hover {
				// 	.zzDay {
				// 		display: block;
				// 	}
				// }
				.header_child:nth-child(5):hover {
					.goverment {
						display: block;
					}
				}

				.header_child:nth-child(4):hover {
					.technologyList {
						display: block;
					}
				}

				.header_child:nth-child(3):hover {
					.aboutus {
						display: block;
					}
				}

				.header_child:nth-child(2):hover {
					.service {
						display: block;
					}
				}
			}

			.finMatrixNav {
				position: relative;
				text-align: center;
				min-width: 132px;
				padding: 40px 12px;
				line-height: 16px;
				font-family: AlibabaPuHuiTiR;
				font-size: 16px;
				color: #ffffff;
				cursor: pointer;

				&:hover {
					animation: big .3s linear forwards;

					.finMatrixMenu {
						display: block;
					}
				}

				.finMatrixMenu {
					display: none;
					position: absolute;
					top: 96px;
					left: 50%;
					transform: translateX(-50%);
					background-color: #fff;
					min-width: 160px;
					z-index: 200;
					box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);

					.child {
						width: 100%;
						padding: 16px 14px;
						font-family: AlibabaPuHuiTiR;
						font-size: 15px;
						color: #666;
						text-align: center;
						white-space: nowrap;
					}

					.child:hover {
						animation: change .3s linear forwards;
					}
				}
			}

			.search {
				width: 200px;
				padding: 10px 20px;
				border-radius: 30px;
				background-color: rgba(0, 0, 0, 0.4);
				cursor: pointer;

				input {
					flex-grow: 1;
					cursor: pointer;
					line-height: 20px;
					background-color: transparent;
					color: #fff;
				}

				img {
					width: 20px;
					height: 20px;
					cursor: pointer;
				}
			}
		}

	}

	.headerss {
		position: fixed;
		top: 0;
		width: 100%;
		z-index: 9999;
		max-width: 1920px;
		background-color: rgba(11, 79, 221, 1);

		.herder_left {
			margin-left: 4vw;
			cursor: pointer;

			img {
				object-fit: fill;
				width: 230px;
				height: 50px;
			}
		}

		.herder_left:hover {
			animation: bigs .3s linear forwards;
		}

		.right {
			.herder_right {
				position: relative;

				.header_child {
					text-align: center;
					width: 133px;
					padding: 40px 0;
					line-height: 16px;
					font-family: AlibabaPuHuiTiR;
					font-size: 16px;
					color: #ffffff;
					cursor: pointer;
					position: relative;
				}

				.header_child:hover {
					animation: big .3s linear forwards;

					// .child{
					// 	font-weight: 400;
					// }
				}

				.service {
					display: none;
					position: absolute;
					top: 96px;
					background-color: #fff;
					width: 110px;
					margin: 0 15px;

					.child {
						width: 100%;
						padding: 20px 0;
						font-family: AlibabaPuHuiTiR;
						font-size: 16px;
						color: #666;
						opacity: 0.68;
						text-align: center;
					}

					.child:hover {
						animation: change .3s linear forwards;
					}
				}

				.aboutus {
					display: none;
					position: absolute;
					top: 96px;
					background-color: #fff;
					width: 110px;
					margin: 0 15px;

					.child {
						width: 100%;
						padding: 20px 0;
						font-family: AlibabaPuHuiTiR;
						font-size: 16px;
						color: #666;
						opacity: 0.68;
						text-align: center;
					}

					.child:hover {
						animation: change .3s linear forwards;
					}
				}

				.technologyList {
					display: none;
					position: absolute;
					top: 96px;
					background-color: #fff;
					width: 110px;
					margin: 0 15px;

					.child {
						width: 100%;
						padding: 20px 0;
						font-family: AlibabaPuHuiTiR;
						font-size: 16px;
						color: #666;
						opacity: 0.68;
						text-align: center;
					}

					.child:hover {
						animation: change .3s linear forwards;
					}
				}

				.zzDay {
					display: none;
					position: absolute;
					top: 96px;
					background-color: #fff;
					width: 110px;
					margin: 0 15px;

					.child {
						width: 100%;
						padding: 20px 0;
						font-size: 16px;
						color: #666;
						opacity: 0.68;
						text-align: center;
					}

					.child:hover {
						animation: change .3s linear forwards;
					}
				}

				.goverment {
					display: none;
					position: absolute;
					top: 96px;
					right: 0;
					background-color: #fff;
					width: 110px;
					margin: 0 15px;

					.child {
						width: 100%;
						padding: 20px 0;
						font-size: 16px;
						color: #666;
						opacity: 0.68;
						text-align: center;
					}

					.child:hover {
						animation: change .3s linear forwards;
					}
				}

				.header_childs {
					text-align: center;
					width: 150px;
					padding: 20px 0;
					font-family: AlibabaPuHuiTiR;
					font-size: 14px;
					color: #666;
					background-color: #0049ac;
					cursor: pointer;
				}

				// 含「投教基地」共六项导航时，政策资讯为第6个子项：
				// .header_child:nth-child(6):hover {
				// 	.goverment {
				// 		display: block;
				// 	}
				// }
				// .header_child:nth-child(5):hover {
				// 	.zzDay {
				// 		display: block;
				// 	}
				// }
				.header_child:nth-child(5):hover {
					.goverment {
						display: block;
					}
				}

				.header_child:nth-child(4):hover {
					.technologyList {
						display: block;
					}
				}

				.header_child:nth-child(3):hover {
					.aboutus {
						display: block;
					}
				}

				.header_child:nth-child(2):hover {
					.service {
						display: block;
					}
				}
			}

			.finMatrixNav {
				position: relative;
				text-align: center;
				min-width: 133px;
				padding: 40px 12px;
				line-height: 16px;
				font-family: AlibabaPuHuiTiR;
				font-size: 16px;
				color: #ffffff;
				cursor: pointer;

				&:hover {
					animation: big .3s linear forwards;

					.finMatrixMenu {
						display: block;
					}
				}

				.finMatrixMenu {
					display: none;
					position: absolute;
					top: 96px;
					left: 50%;
					transform: translateX(-50%);
					background-color: #fff;
					min-width: 160px;
					z-index: 200;
					box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);

					.child {
						width: 100%;
						padding: 16px 14px;
						font-family: AlibabaPuHuiTiR;
						font-size: 15px;
						color: #666;
						text-align: center;
						white-space: nowrap;
					}

					.child:hover {
						animation: change .3s linear forwards;
					}
				}
			}
		}

		.search {
			margin-right: 4vw;
			width: 200px;
			padding: 10px 20px;
			border-radius: 30px;
			background-color: rgba(0, 0, 0, 0.4);
			cursor: pointer;

			input {
				flex-grow: 1;
				cursor: pointer;
				line-height: 20px;
				background-color: transparent;
				color: #fff;
			}

			img {
				width: 20px;
				height: 20px;
				cursor: pointer;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// headerTop.vue?7ecfbdfd